import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { Table as TableComponent } from '@src/shared/ui/components/TableStatic';
import { dayjs } from '@uhg-abyss/web/tools/dayjs';
import { Heading } from '@uhg-abyss/web/ui/Heading';
import { orderBy } from 'lodash';
import React, { useMemo } from 'react';

import configuration from './includes/configuration.json';

/**
 * Table
 *
 * Table to show recommendations from source.
 *
 * @param recommendationResponses
 * @returns {Element}
 * @constructor
 */
export function Table({ recommendationResponses }) {
  /**
   * renderCellDobLastModified
   *
   * Displays the date of birth last modified in a particular date/time format.
   *
   * @param value
   * @returns {*|string}
   */
  const renderCellStatusDate = ({ value }) => {
    return dayjs(value).format('MM/DD/YYYY, HH:mm:ss');
  };

  /**
   * Columns for table.
   */
  const columns = useMemo(() => {
    return orderBy(configuration?.initialColumns, ['order'], ['asc']).map((item) => {
      const column = item;

      if (column?.Header === 'Status Date') {
        column.Cell = renderCellStatusDate;
      }

      return column;
    });
  }, []);

  return (
    <ErrorHandler location="src/widgets/RiskRecords/ActionPaths/components/RecommendationResponses/components/Table/Table.jsx">
      <Heading
        css={{ marginBottom: 'var(--abyss-space-md) !important', marginTop: 'var(--abyss-space-sm)' }}
        offset={5}
      >
        Recommendation Responses
      </Heading>
      <TableComponent
        {...{
          accessor: 'eidSearch-actionPaths-RecommendationResponses',
          columns,
          configuration,
          noDataMessage: 'No recommendation responses found.',
          rows: recommendationResponses,
        }}
      />
    </ErrorHandler>
  );
}
